import Vue from 'vue';
import {
    FormModel,
    Modal,
    message,
    Input,
    Row,
    Col,
    Table,
    Button,
    Dropdown,
    Menu,
    Radio,
    Icon,
    Tabs,
    Select,
    notification,
    Tag,
    Tooltip,
    Upload,
    Divider,
    Steps,
} from 'ant-design-vue';

import {
    LxtForm,
    LxtInput,
    LxtTable,
    LxtButtonGroup,
    LxtSearchBar,
    LxtSearchTable,
    LxtDetail,
} from '@lxt/ant-component-vue';
import Dialog1 from '@/plugins/Dialog1';


const antComponents = [
    FormModel,
    FormModel.Item,
    Modal,
    Row,
    Col,
    Input,
    Input.TextArea,
    Table,
    Button,
    Dropdown,
    Menu,
    Menu.Item,
    Radio,
    Radio.Group,
    Icon,
    Tabs,
    Tabs.TabPane,
    Select,
    Tag,
    Tooltip,
    Upload,
    Divider,
    Steps,
    Steps.Step,
];

antComponents.forEach(i => Vue.component(i.name, i));

Vue.use(Modal);
Vue.prototype.$message1 = message;
Vue.prototype.$notification1 = notification;
Vue.prototype.$info1 = Modal.info;
Vue.prototype.$success1 = Modal.success;
Vue.prototype.$error1 = Modal.error;
Vue.prototype.$warning1 = Modal.warning;
Vue.prototype.$confirm1 = Modal.confirm;
Vue.prototype.$destroyAll1 = Modal.destroyAll;

const components = [
    LxtForm,
    LxtInput,
    LxtTable,
    LxtButtonGroup,
    LxtSearchBar,
    LxtSearchTable,
    LxtDetail,
];

components.forEach(i => Vue.component(i.name, i));

Vue.prototype.$dialog1 = Dialog1;
